import React, { useEffect } from "react";
import { saveAs } from "file-saver";

const DownloadComponent = ({ fileUrl, fileName, onClose }) => {
  const handleDownload = async () => {
    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      saveAs(blob, fileName);
    } catch (error) {
      console.error("Download failed:", error);
    } finally {
      onClose();
    }
  };

  useEffect(() => {
    handleDownload();
  }, []);

  return <p>Downloading...</p>;
};

export default DownloadComponent;